// extracted by mini-css-extract-plugin
export default {"mainDiv":"ChangePassword_mainDiv__k0uPE","formDiv":"ChangePassword_formDiv__X0Mf4","styledInput":"ChangePassword_styledInput__qDIpu"};